import type { SubscriptionStore } from "@/Modules/Subscription/Store";
import type { AppStore } from "@/Modules/App/Store";
import type { ApiError } from "@/Services/Api/Models";
import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { endTrialPeriod } from "@/Services/TherapyApi/Users";

import useAppStore from "@/Modules/App/Store";

class EndTrialPeriodActionHandler {
  constructor(
    private readonly subscriptionStore: SubscriptionStore,
    private readonly appStore: AppStore = useAppStore()
  ) {}

  public async handle(userId: string) {
    this.subscriptionStore.isLoading = true;

    return endTrialPeriod(userId)
      .catch((error: ApiError) => {
        let message: string;

        if (error.error_code === ApiErrorCodes.CREATE_SUBSCRIPTION_ERROR) {
          message = `user.settings.subscription.payment.card_error.${error.detail}`;
        } else {
          message = "there_was_an_error_connecting_to_the_server_please_try_again_later";
        }

        this.appStore.showSnackbar({
          type: NotificationType.ERROR,
          message: message,
        });
      })
      .finally(() => {
        this.subscriptionStore.isLoading = false;
      });
  }
}

export default EndTrialPeriodActionHandler;
